import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowsClockwise, CheckCircle } from '@phosphor-icons/react';

/**
 * Visual indicator component that shows when prices are updating
 * Provides user feedback for real-time data refreshes
 */
const PriceUpdateIndicator = ({ isUpdating, lastUpdate, className = '' }) => {
  const formatTime = (date) => {
    if (!date) return 'Never';
    return new Date(date).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <AnimatePresence>
      {isUpdating && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg bg-gold/10 border border-gold/20 ${className}`}
        >
          <ArrowsClockwise size={16} className="text-gold animate-spin" />
          <span className="text-sm text-gold font-medium">Updating prices...</span>
        </motion.div>
      )}
      {!isUpdating && lastUpdate && (
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg bg-success/10 border border-success/20 ${className}`}
        >
          <CheckCircle size={16} className="text-success" weight="fill" />
          <span className="text-sm text-success font-medium">
            Updated at {formatTime(lastUpdate)}
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PriceUpdateIndicator;
